module.exports = __webpack_public_path__ + "img/company.eb729893.png";